<template>
  <MessageLayout image="./aws-token-expired.svg" title="Expired token">
    Your AWS Marketplace token has expired. Restart the account setup on the AWS
    Marketplace product page to continue the registration process.
  </MessageLayout>
</template>

<script setup lang="ts">
import MessageLayout from "@/modules/messages/MessageLayout.vue";
</script>
